/* eslint-disable */

export enum WidgetSize {
  UNUSED = 0,
  SMALL = 1,
  MEDIUM = 2,
  LARGE = 3,
  /** WIDE - Special type, converted to by pipe with Size = medium + usesWideMediumSize */
  WIDE = 4,
  UNRECOGNIZED = -1,
}

export interface Widget {
  id: string;
  upn: string;
  widget?: string | undefined;
  index?: number | undefined;
  size?: number | undefined;
  setting?: string | undefined;
  zone?:
    | WidgetZone
    | undefined;
  /** Used as join column for widget zone */
  zoneid?: string | undefined;
}

export interface WidgetResponse {
  item: Widget | undefined;
}

export interface WidgetList {
  items: Widget[];
  count?: number | undefined;
}

export interface FindWidgetRequest {
  upn: string;
  id: string;
}

export interface FindManyWidgetRequest {
  upn: string;
}

export interface DeleteOneWidgetRequest {
  upn: string;
  id: string;
  widget: string;
}

export interface WidgetZone {
  id: string;
  name: string;
  upn: string;
  index: number;
  type?: string | undefined;
  widgets: Widget[];
}

export interface FindWidgetZoneRequest {
  upn: string;
  id: string;
}

export interface FindManyWidgetZoneRequest {
  upn: string;
}

export interface ResetWidgetZoneRequest {
  upn: string;
}

export interface WidgetZoneResponse {
  item: WidgetZone | undefined;
}

export interface WidgetZoneList {
  items: WidgetZone[];
  count?: number | undefined;
}
